import axios from 'axios';

const api = axios.create({
	baseURL: "https://planilhacifal.ddns.net:2971",
	headers: {
	}
});

export default api;
